import { Trans } from '@lingui/react'

import { useFlowQuery } from '@twisto/api-graphql'
import { CircleLoader } from '@twisto/components/atoms/circle-loader'
import { Flex } from '@twisto/components/atoms/flex'
import {
  Headline,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'

import { useFlow } from '../../flow/flow.context'

import * as styles from './risk-check-processing-step.styles'

const POLL_INTERVAL = 1000

/**
 *
 * @deprecated use ProcessingStep instead
 */
export const RiskCheckProcessingStep = () => {
  const { sessionId } = useFlow<'RiskCheckProcessingStep'>()
  useFlowQuery({
    variables: {
      auth: {
        sessionId,
      },
    },
    pollInterval: POLL_INTERVAL,
    fetchPolicy: 'network-only',
  })

  return (
    <Flex fullHeight alignItems="center" direction="column" justify="center">
      <CircleLoader css={styles.circleLoader} />
      <Headline>
        <HeadlineTitle>
          <Trans id="flow.riskCheckProcessingStep.title" />
        </HeadlineTitle>
        <HeadlineSubtitle>
          <Trans id="flow.riskCheckProcessingStep.subtitle" />
        </HeadlineSubtitle>
      </Headline>
    </Flex>
  )
}
